import React, { useState } from 'react';

import { Text, TextArea } from 'shell/components';

const TextAreaDemo = () => {
    const [value, setValue] = useState('');

    return (
        <>
            <Text variant={'sh1'}>TextArea</Text>

            <TextArea placeholder={'Placeholder'} rows={4} />
            <TextArea error placeholder={'Placeholder'} rows={4} />
            <TextArea disabled placeholder={'Placeholder'} rows={4} />

            <TextArea label={'Form label'} placeholder={'Placeholder'} rows={4} />
            <TextArea error label={'Form label'} placeholder={'Placeholder'} rows={4} />
            <TextArea disabled label={'Form label'} placeholder={'Placeholder'} rows={4} />

            <TextArea label={'Form label'} placeholder={'Placeholder'} required rows={4} />
            <TextArea error label={'Form label'} placeholder={'Placeholder'} required rows={4} />
            <TextArea disabled label={'Form label'} placeholder={'Placeholder'} required rows={4} />

            <TextArea
                helperText={`${value.length} characters`}
                label={'Form label'}
                placeholder={'Placeholder'}
                required
                rows={4}
                value={value}
                onChange={(e) => setValue(e.target.value)}
            />
            <TextArea
                error
                helperText={`${value.length} characters`}
                label={'Form label'}
                placeholder={'Placeholder'}
                required
                rows={4}
                value={value}
                onChange={(e) => setValue(e.target.value)}
            />
            <TextArea
                disabled
                helperText={`${value.length} characters`}
                label={'Form label'}
                placeholder={'Placeholder'}
                required
                rows={4}
                value={value}
                onChange={(e) => setValue(e.target.value)}
            />

            <TextArea
                helperText={`${value.length} characters`}
                helperTextPosition={'end'}
                label={'Form label'}
                placeholder={'Placeholder'}
                required
                rows={4}
                value={value}
                onChange={(e) => setValue(e.target.value)}
            />
            <TextArea
                error
                helperText={`${value.length} characters`}
                helperTextPosition={'end'}
                label={'Form label'}
                placeholder={'Placeholder'}
                required
                rows={4}
                value={value}
                onChange={(e) => setValue(e.target.value)}
            />
            <TextArea
                disabled
                helperText={`${value.length} characters`}
                helperTextPosition={'end'}
                label={'Form label'}
                placeholder={'Placeholder'}
                required
                rows={4}
                value={value}
                onChange={(e) => setValue(e.target.value)}
            />
        </>
    );
};

export default TextAreaDemo;
